import { createFileRoute } from "@tanstack/react-router";

// The thread itself renders in the right pane (see WorkspaceShell); this route only carries the params.
export const Route = createFileRoute("/w/$ws/c/$channel/t/$root")({ component: () => null });
